// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthForm_auth__MPw6W","control":"AuthForm_control__2fVSU","actions":"AuthForm_actions__1VNhY","toggle":"AuthForm_toggle__21tnB","invalid":"AuthForm_invalid__2xOpm"};